import { IRecomendedOfferSchema } from '../../types/recommendedOffer';

export enum EBookedOfferRecommendationsActionTypes {
  SetBookedOfferRecommendations = 'bookedOfferRecommendations/set',
}

export interface ISetBookedOfferRecommendationsAction {
  type: EBookedOfferRecommendationsActionTypes.SetBookedOfferRecommendations;
  payload: IRecomendedOfferSchema[];
}

export type TBookedOfferRecommendationsActions = ISetBookedOfferRecommendationsAction;

/* istanbul ignore next */
export const setBookedOfferRecommendations = (
  recommendations: IRecomendedOfferSchema[],
): ISetBookedOfferRecommendationsAction => ({
  type: EBookedOfferRecommendationsActionTypes.SetBookedOfferRecommendations,
  payload: recommendations,
});
